import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useEffect, useState, useCallback, useMemo } from 'react';
import { fetchUserAttributes } from 'collaboration-sidebar/api/UserSettings';
import { getUserAttributesArray } from '../constants/userAttributes';
const INITIAL_STATE = {
  loading: true,
  error: null,
  settings: undefined
};
export const UserSettingsContext = /*#__PURE__*/createContext(Object.assign({}, INITIAL_STATE, {
  setState: () => {}
}));
export default function UserSettingsProvider({
  children,
  objectType,
  objectId
}) {
  const [state, setState] = useState(INITIAL_STATE);
  const fetchUserSettings = useCallback(() => {
    if (!objectId) {
      return;
    }

    setState({
      loading: true,
      error: null
    });
    const keysToFetch = getUserAttributesArray(objectType, objectId);
    fetchUserAttributes(keysToFetch).then(payload => {
      setState({
        loading: false,
        error: null,
        settings: payload.attributes || []
      });
    }).catch(error => {
      setState({
        loading: false,
        error,
        settings: undefined
      });
    });
  }, [objectType, objectId]);
  useEffect(() => {
    fetchUserSettings();
  }, [fetchUserSettings]);
  const userSettingsState = useMemo(() => Object.assign({}, state, {
    setState
  }), [state]);
  return /*#__PURE__*/_jsx(UserSettingsContext.Provider, {
    value: userSettingsState,
    children: children
  });
}